<template>
    <div class="relative inline-block text-left">
        <div>
            <button type="button" @click="open = !open" class="">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-4 w-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"
                    />
                </svg>

                <SlideOver :show="open" @close="open = false">
                    <div>
                        <ul>
                            <li v-for="(suggestion, index) in suggestions" :key="index">
                                <button
                                    class="mt-1 pt-2 bg-gray-50 hover:bg-indgo-100 block w-full rounded-md"
                                    @click="insert(suggestion)"
                                >
                                    {{ suggestion }}
                                </button>
                            </li>
                        </ul>
                    </div>
                </SlideOver>
            </button>
        </div>
    </div>
</template>

<script>
import SlideOver from '@/components/SlideOver.vue';

export default {
    components: { SlideOver },
    data() {
        return {
            open: false,
            suggestions: [
                'AAAAAAAAAAAAAAAAA',
                'Avisos reiterats per distorsionar el correcte funcionament de la classe.',
                'Ha estat menjant xiclet a l’escola.',
                'S’ha hagut de cridar l’atenció a l’infant per intervencions reiterades sense respectar el torn de paraula.',
                'L’infant ha faltat el respecte a un membre de la comunitat educativa.',
                "Mentre es pujava la fila, l’infant no ha respectat l'ordre ni la tranquil·litat requerida molestant a la resta dels infants.",
                'L’infant no ha respectat les normes del joc a l’hora del pati fet que ha derivat en conflictes amb altres infants.',
                'S’ha hagut d’avisar diverses vegades a l’infant per aixecar-se durant una activitat molestant a la resta.',
                'L’infant ha distorsionat el normal funcionament de la classe.',
                'L’infant ha embrutat o malmès les instal·lacions/materials de l’escola. ',
                'S’ha fet un ús no acadèmic d’un dispositiu (ordinador, tauleta, etc.).',
                'L’infant ha agredit físicament/verbalment o digitalment a un membre de la comunitat educativa. ',
                'L’infant ha sortit de l’aula o del centre sense permís.',
                'L’infant ha mostrat un comportament inadequat en les activitats pedagògiques fora del centre.',
            ],
        };
    },
    props: {
        name: {
            type: String,
            required: true,
        },
    },
    methods: {
        insert(suggestion) {
            let value = document.getElementById(this.name).value;

            if (value !== '') {
                value += '\n\n';
            }

            document.getElementById(this.name).value = value + suggestion;

            this.open = false;
        },
    },
};
</script>
